import { Pipe, PipeTransform } from '@angular/core';
import { AuthFacade } from 'app/auth/auth.facade';
import { AuthAccess } from 'app/auth/models/auth-access';
import { AuthAccessLogicalType } from 'app/auth/models/auth-access-logical-type';
import { PolicyType } from 'app/auth/models/policy-type';
import { RoleType } from 'app/auth/models/role-type';
import { AuthAccessUtils } from 'app/auth/utils/auth-access-utils';
import { map, Observable } from 'rxjs';

@Pipe({
  name: 'auth',
  standalone: true,
})
export class AuthPipe implements PipeTransform {

  adminRoles: AuthAccess[] = [
    {
      policiesAccess: [],
      rolesAccess: [RoleType.Administrator_Full]
    },
  ];

  constructor(private authFacade: AuthFacade, private authAccessUtils: AuthAccessUtils) {
  }

  /**
   * Checks wheter loged in user has access based on received roles or not
   * @param authAccess array of roles/groups with access
   * @param authAccessLogicalType logic with witch evaluate access
   * @param includeAdmin wheter or not admin roles should be considered in the evaluation
   * @returns Observable<boolean> with info about access (true => has access, false => don't have access)
   */
  transform(authAccess?: AuthAccess[], authAccessLogicalType: AuthAccessLogicalType = AuthAccessLogicalType.Or, includeAdmin = true): Observable<boolean> {
    return this.authFacade.user$.pipe(map((user) => {
        if (user && user.policies && user.roles && authAccess) {
          return this.authAccessUtils.evaluationOfAuths(
            user.policies,
            user.roles,
            includeAdmin ? [...authAccess, ...this.adminRoles] : authAccess,
            authAccessLogicalType
          );
        } else {
          return true;
        }
      }))
  }

}
